import { RefObject, useEffect, useState } from 'react';

export const useSelectedMarkerPopupReady = (
  ref: RefObject<L.Marker>,
  isSelected: boolean,
  interval = 50,
  timeout = 5000,
) => {
  const [openPopupReady, setOpenPopupReady] = useState<boolean>(false);

  // Fixme: This effect logic looks flaky and includes type conversion to access assumed Leaflet internals.
  // We need a more dependable solution for something as important as navigating to assets.
  useEffect(() => {
    if (isSelected) {
      let elapsed = 0;
      const timer = setInterval(() => {
        const marker = ref.current;
        if (marker && typeof marker.getPopup === 'function') {
          const popup = marker.getPopup();
          // We want to check that the marker has been added to the map
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          if (popup && typeof popup?.openPopup === 'function' && !!(marker as any)?._map) {
            clearInterval(timer);
            setOpenPopupReady(true);
          }
        }
        elapsed += interval;
        if (elapsed >= timeout) {
          clearInterval(timer);
          console.warn('Popup not found within timeout');
        }
      }, interval);

      return () => clearInterval(timer);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref]);

  return openPopupReady;
};
